import * as betprofessor from './SecondaryLayout.styles.betprofessor';
import * as betroyale from './SecondaryLayout.styles.betroyale';
import * as fiestabet from './SecondaryLayout.styles.fiestabet';
import * as goldenrush from './SecondaryLayout.styles.goldenrush';
import * as juicybet from './SecondaryLayout.styles.juicybet';
import * as puntcity from './SecondaryLayout.styles.puntcity';
import * as puntgenie from './SecondaryLayout.styles.puntgenie';
import * as questbet from './SecondaryLayout.styles.questbet';
import * as sterlingparker from './SecondaryLayout.styles.sterlingparker';
import * as vikingbet from './SecondaryLayout.styles.vikingbet';
import * as volcanobet from './SecondaryLayout.styles.volcanobet';
import * as wellbet from './SecondaryLayout.styles.wellbet';
import * as forsport from './SecondaryLayout.styles.forsport';
import * as junglebet from './SecondaryLayout.styles.junglebet';
import * as oldgill from './SecondaryLayout.styles.oldgill';
import * as sugarcastle from './SecondaryLayout.styles.sugarcastle';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
};
